export class EditCondition {
	public empCd: string
	public empNm: string
	public loginId: string
	public oldPassword: string
	public newPassword: string
	public newPasswordConfirm: string
	public renewDate: Date
	public renewUser: string
	public renewUserNm: string
}
